{
	"accounts": "Account",
	"invitations": "Inviti",
	"subscribeToFeedback": "Iscriviti al programma di feedback",
	"notificationSettings": {
		"title": "Impostazioni notifiche e-mail",
		"invoicingInformation": "Informazioni di fatturazione",
		"declarationProcessingStatus": "Stato di elaborazione della dichiarazione",
		"enabled": "Attivo",
		"disabled": "Disattivo",
		"toast": {
			"success": "Preferenza di notifica aggiornata",
			"error": "Impossibile aggiornare la preferenza di notifica"
		}
	},
	"about": {
		"title": "Informazioni",
		"termsAndConditions": "Termini e condizioni",
		"privacyPolicy": "Informativa sulla privacy",
		"imprint": "Note legali",
		"openSourceAttribution": "Attribuzione open source"
	},
	"language": {
		"title": "Lingua",
		"footer": "Le modifiche della lingua si applicheranno a tutte le applicazioni Heidelberg Materials"
	},
	"impressum": "Note legali",
	"copyright": "© 2024 Heidelberg Materials. Tutti i diritti riservati.",
	"login": "Accedi",
	"logout": "Esci"
}
